import { render, staticRenderFns } from "./VoiceCallConfig.vue?vue&type=template&id=805cbe56&scoped=true"
import script from "./VoiceCallConfig.vue?vue&type=script&lang=js"
export * from "./VoiceCallConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805cbe56",
  null
  
)

export default component.exports